module.exports = __webpack_public_path__ + "7d088296/img/ion_calendar-number.3ac5bd07.svg";